"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Tabs_1 = require("./Tabs");
Object.defineProperty(exports, "Tabs", { enumerable: true, get: function () { return Tabs_1.Tabs; } });
var TabItem_1 = require("./TabItem");
Object.defineProperty(exports, "TabItem", { enumerable: true, get: function () { return TabItem_1.TabItem; } });
//# sourceMappingURL=index.js.map